export default __webpack_public_path__ + "static/media/Pickpocket's Gloves of the Nadir.b7d7ec01.jpg";